import axios from 'axios';
import { pipe, path, partial } from 'ramda';

import {
  FETCH_USER_FORM,
  FETCH_USER_FORM_SUCCESS,
  FETCH_USER_FORM_ERROR,
  SAVE_USER_FORM,
  SAVE_USER_FORM_SUCCESS,
  SAVE_USER_FORM_ERROR,
  UPDATE_USER_FORM_FIELD,
  RESET_ERROR,
} from './constants';

const getFields = (items) => ({
  fields: items.reduce((acc, block) => [...acc, ...block.fields.reduce((fields, field) => (field.value ? [...fields, {
    id: field.id,
    value: field.value,
  }] : fields), [])], []),
});

const saveFieldsFromState = pipe(
  path(['personalData', 'items']),
  getFields,
  partial(axios.post, ['/api/profile/personaldata/personaldataform/']),
);

export function fetchUserFormStart() {
  return {
    type: FETCH_USER_FORM,
  };
}

export function fetchUserFormSuccess(data) {
  return {
    data,
    type: FETCH_USER_FORM_SUCCESS,
  };
}

export function fetchUserFormError(error) {
  return {
    error,
    type: FETCH_USER_FORM_ERROR,
  };
}

export function saveUserFormStart() {
  return {
    type: SAVE_USER_FORM,
  };
}

export function saveUserFormSuccess() {
  return {
    type: SAVE_USER_FORM_SUCCESS,
  };
}

export function saveUserFormError(error) {
  return {
    error,
    type: SAVE_USER_FORM_ERROR,
  };
}

export function updateField(data) {
  return {
    data,
    type: UPDATE_USER_FORM_FIELD,
  };
}

export function resetError() {
  return {
    type: RESET_ERROR,
  };
}

function patchInitialForm(fields) {
  const countriesComparator = (a, b) => {
    if (a.code === 'RUS') return -1;
    if (b.code === 'RUS') return 1;
    if (a.code === '000') return 1;
    if (b.code === '000') return -1;
    return a.code > b.code ? 1 : -1;
  };

  const citizenshipGroup = fields.find(({ groupId }) => groupId === 3);
  const citizenshipField = citizenshipGroup.fields.find(({ id }) => id === 9);
  const docTypeField = citizenshipGroup.fields.find(({ id }) => id === 10);
  const foreignDocTypeField = citizenshipGroup.fields.find(({ id }) => id === 28);
  citizenshipField.options.sort(countriesComparator);
  citizenshipField.value = 'RUS';
  docTypeField.value = '1';
  foreignDocTypeField.value = '4';

  const adressGroup = fields.find(({ groupId }) => groupId === 4);
  const countryField = adressGroup.fields.find(({ id }) => id === 54);
  countryField.options.sort(countriesComparator);

  const factAdressGroup = fields.find(({ groupId }) => groupId === 5);
  const factCountryField = factAdressGroup.fields.find(({ id }) => id === 66);
  factCountryField.options.sort(countriesComparator);
}

export function fetchUserForm(formFieldsFromProps) {
  return async (dispatch) => {
    dispatch(fetchUserFormStart());

    try {
      let formFields = formFieldsFromProps;

      if (!formFieldsFromProps) {
        const { data } = await axios.get('/api/profile/personaldata/');
        formFields = data.form.formFields;
      }
      if (formFields) {
        patchInitialForm(formFields);
        dispatch(fetchUserFormSuccess(formFields));
      }
    } catch (error) {
      dispatch(fetchUserFormError({ code: 500 }));
    }
  };
}

export function saveUserForm(saveHandler) {
  return async (dispatch, getState) => {
    dispatch(saveUserFormStart());

    try {
      const resp = saveHandler
        ? await saveHandler(getFields(path(['personalData', 'items'], getState())))
        : await saveFieldsFromState(getState());
      const { isSuccess, errorMessage, errorCode, errorIds } = resp.data;

      if (isSuccess) {
        dispatch(saveUserFormSuccess());
      } else {
        dispatch(saveUserFormError({
          message: errorMessage,
          code: errorCode,
          errorIds,
        }));
      }
    } catch (error) {
      dispatch(saveUserFormError(error));
    }
  };
}

export function fetchInitialData(formFields) {
  return (dispatch) => {
    dispatch(resetError());
    dispatch(fetchUserForm(formFields));
  };
}
